import Box from '@zenbusiness/zui/Box';
import Heading from '@zenbusiness/zui/Heading';
import IconButton from '@zenbusiness/zui/IconButton';
import LoadingButton from '@zenbusiness/zui/LoadingButton';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import {
  DialogContentTextStyled,
  DialogHeaderStyled,
  DialogStyled
} from './ExitConfirmModal.styles';

const CloseIcon = (
  <SharedAsset
    alt=""
    src="/icon/micro/close-x.svg"
  />
);

export default function ExitConfirmModal({
  handleClose,
  onOk,
  title,
  description,
  okText,
  cancelText,
  callback
}) {
  const closeHandler = () => {
    handleClose();
    if (typeof callback === 'function') {
      callback();
    }
  };

  return (
    <DialogStyled
      fullWidth
      onClose={closeHandler}
      open
    >
      <DialogHeaderStyled>
        <Box />
        <IconButton
          label="close"
          onClick={closeHandler}
        >
          {CloseIcon}
        </IconButton>
      </DialogHeaderStyled>
      <DialogContentTextStyled component="div">
        <Stack spacing="32px">
          <Stack
            alignItems="center"
            direction="column"
            spacing="16px"
          >
            <Heading
              align="center"
              family="secondary"
              size="3xl"
              weight="bold"
            >
              {title}
            </Heading>
            <Text
              align="center"
              color="primary"
              size="md"
            >
              {description}
            </Text>
          </Stack>
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="center"
            spacing="8px"
          >
            {cancelText && (
              <LoadingButton
                color="primary"
                fullWidth={!okText}
                onClick={closeHandler}
                size="md"
                variant="outlined"
              >
                {cancelText}
              </LoadingButton>
            )}
            {okText && (
              <LoadingButton
                color="error"
                fullWidth={!cancelText}
                onClick={onOk}
                size="md"
                variant="contained"
              >
                {okText}
              </LoadingButton>
            )}
          </Stack>
        </Stack>
      </DialogContentTextStyled>
    </DialogStyled>
  );
}

ExitConfirmModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  onOk: PropTypes.func,
  callback: PropTypes.func,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string
};
